const pagesCustomerLedgerEn = {
  billToFieldAttention: 'Attention / Department',
  billToFieldBp: 'Bill-To BP',
  billToFieldCity: 'City',
  billToFieldCountryCode: 'Country Code',
  billToFieldEmail: 'Email',
  billToFieldFax: 'Fax',
  billToFieldIsDefaultFlag: 'Default Bill-To',
  billToFieldPhone: 'Phone',
  billToFieldPostalCode: 'Postal Code',
  billToFieldStateProvince: 'State / Province',
  billToFieldStreet1: 'Street 1',
  billToFieldStreet2: 'Street 2',
  billToFieldTaxId: 'Tax ID',
  billToFieldVatRegistrationNumber: 'VAT Registration Number',
  commercialTermsAddBillTo: 'Add Bill-To',
  commercialTermsAddEntry: 'Add Commercial Terms',
  commercialTermsAddPayer: 'Add Payer',
  commercialTermsBillToCount: 'Bill-To: {{count}}',
  commercialTermsBillToItemLabel: 'Bill-To {{index}}',
  commercialTermsEntryLabel: 'Commercial Terms',
  commercialTermsGroupAdvancePayments: 'Advance Payments & Deposits',
  commercialTermsGroupBillTo: 'Bill-To',
  commercialTermsGroupInvoice: 'Invoice Format & Submission',
  commercialTermsGroupPayer: 'Payer',
  commercialTermsGroupPaymentMethods: 'Payment Methods',
  commercialTermsGroupPaymentTerms: 'Payment Terms',
  commercialTermsNoEntries: 'No commercial terms found.',
  commercialTermsPayerCount: 'Payer: {{count}}',
  commercialTermsPayerItemLabel: 'Payer {{index}}',
  ctFieldAdvancePaymentDepositCurrency: 'Advance Payment / Deposit Currency',
  ctFieldAdvancePaymentReceivedAmount: 'Advance Payment Received Amount',
  ctFieldBaselineDateType: 'Baseline Date Type',
  ctFieldCashDiscountBase: 'Cash Discount Base',
  ctFieldCreditCardBrand: 'Credit Card Brand',
  ctFieldCreditCardExpiryMonth: 'Credit Card Expiry Month',
  ctFieldCreditCardExpiryYear: 'Credit Card Expiry Year',
  ctFieldCreditCardLastFour: 'Credit Card Last Four',
  ctFieldCreditNotePolicy: 'Credit Note Policy',
  ctFieldDefaultPaymentMethod: 'Default Payment Method',
  ctFieldDepositApplyToInvoicesFlag: 'Apply Deposit to Invoices',
  ctFieldDepositOnFileAmount: 'Deposit On File Amount',
  ctFieldDirectDebitMandateStatus: 'Direct Debit Mandate Status',
  ctFieldEInvoicingCustomerId: 'E-Invoicing Customer ID',
  ctFieldEInvoicingFormat: 'E-Invoicing Format',
  ctFieldEInvoicingRequiredFlag: 'E-Invoicing Required',
  ctFieldEarlyPayDiscountDays: 'Early Pay Discount Days',
  ctFieldEarlyPayDiscountRate: 'Early Pay Discount Rate (%)',
  ctFieldInvoiceConsolidationCycle: 'Invoice Consolidation Cycle',
  ctFieldInvoiceConsolidationGroup: 'Invoice Consolidation Group',
  ctFieldInvoiceCurrency: 'Invoice Currency',
  ctFieldInvoiceDeliveryMethod: 'Invoice Delivery Method',
  ctFieldInvoiceFormat: 'Invoice Format',
  ctFieldInvoiceLanguage: 'Invoice Language',
  ctFieldLatePaymentInterestRate: 'Late Payment Interest Rate (%)',
  ctFieldNetDueDays: 'Net Due Days',
  ctFieldPaymentMethodOnFileFlag: 'Payment Method On File',
  ctFieldPaymentTermsCode: 'Payment Terms Code',
  ctFieldPaymentTermsDescription: 'Payment Terms Description',
  ctFieldPaymentTermsNegotiationDate: 'Payment Terms Negotiation Date',
  ctFieldPaymentTermsNextReviewDate: 'Payment Terms Next Review Date',
  ctFieldPaymentTermsSource: 'Payment Terms Source',
  ctFieldPoNumberOnInvoiceRequiredFlag: 'PO Number on Invoice Required',
  ctFieldPreferredPaymentCurrency: 'Preferred Payment Currency',
  ctFieldPrepaymentPercentageRequired: 'Prepayment Percentage Required (%)',
  ctFieldPrepaymentRequiredFlag: 'Prepayment Required',
  ctFieldSeparateInvoicePerOrderFlag: 'Separate Invoice Per Order',
  ctOptBaselineDateTypeDeliveryDate: 'Delivery Date',
  ctOptBaselineDateTypeGoodsReceipt: 'Goods Receipt',
  ctOptBaselineDateTypeInvoiceDate: 'Invoice Date',
  ctOptBaselineDateTypePostingDate: 'Posting Date',
  ctOptCashDiscountBaseGrossAmount: 'Gross Amount',
  ctOptCashDiscountBaseNetAmount: 'Net Amount',
  ctOptCashDiscountBaseTaxExcluded: 'Tax Excluded',
  ctOptDefaultPaymentMethodBankTransfer: 'Bank Transfer',
  ctOptDefaultPaymentMethodCheck: 'Check',
  ctOptDefaultPaymentMethodCod: 'Cash on Delivery',
  ctOptDefaultPaymentMethodCreditCard: 'Credit Card',
  ctOptDefaultPaymentMethodDigitalWallet: 'Digital Wallet',
  ctOptDefaultPaymentMethodDirectDebit: 'Direct Debit',
  ctOptDefaultPaymentMethodPaypal: 'PayPal',
  ctOptDirectDebitMandateStatusActive: 'Active',
  ctOptDirectDebitMandateStatusCancelled: 'Cancelled',
  ctOptDirectDebitMandateStatusPending: 'Pending',
  ctOptDirectDebitMandateStatusSuspended: 'Suspended',
  ctOptEInvoicingFormatCfdi: 'CFDI',
  ctOptEInvoicingFormatFatturaPa: 'FatturaPA',
  ctOptEInvoicingFormatJpPint: 'JP PINT',
  ctOptEInvoicingFormatPeppol: 'PEPPOL',
  ctOptEInvoicingFormatXrechnung: 'XRechnung',
  ctOptInvoiceConsolidationCycleMonthly: 'Monthly',
  ctOptInvoiceConsolidationCyclePerOrder: 'Per Order',
  ctOptInvoiceConsolidationCycleSemiMonthly: 'Semi-Monthly',
  ctOptInvoiceConsolidationCycleWeekly: 'Weekly',
  ctOptInvoiceDeliveryMethodApi: 'API',
  ctOptInvoiceDeliveryMethodEdi: 'EDI',
  ctOptInvoiceDeliveryMethodEmail: 'Email',
  ctOptInvoiceDeliveryMethodPortal: 'Portal',
  ctOptInvoiceDeliveryMethodPost: 'Post',
  ctOptInvoiceFormatCsv: 'CSV',
  ctOptInvoiceFormatEdiX12: 'EDI X12',
  ctOptInvoiceFormatEdifact: 'EDIFACT',
  ctOptInvoiceFormatPdf: 'PDF',
  ctOptInvoiceFormatPeppolPint: 'PEPPOL PINT',
  ctOptInvoiceFormatUbl: 'UBL',
  ctOptInvoiceFormatXrechnung: 'XRechnung',
  ctOptInvoiceFormatZugferd: 'ZUGFeRD',
  ctOptPaymentTermsCodeCod: 'COD',
  ctOptPaymentTermsCodeInstantPay: 'Instant Pay',
  ctOptPaymentTermsCodeNet30: 'NET 30',
  ctOptPaymentTermsCodeNet60: 'NET 60',
  ctOptPaymentTermsCodeNet210Net30: '2/10 NET 30',
  ctOptPaymentTermsCodePrepay: 'Prepayment',
  ctOptPaymentTermsSourceContract: 'Contract',
  ctOptPaymentTermsSourceCustomerMaster: 'Customer Master',
  ctOptPaymentTermsSourceInvoiceOverride: 'Invoice Override',
  detailBodyBusinessPartnerLink: 'Business Partner',
  detailBodyNoDataMessage: 'No data available in this section.',
  detailBodyTerminateConfirmDescription: 'Set the CUS status to Terminated? This customer will no longer be editable after the change.',
  detailBodyTerminateConfirmTitle: 'Set status to Terminated?',
  detailHeaderUntitled: 'Customer',
  detailTabsCommercialTerms: 'Sales & Commercial Terms',
  detailTabsCompliance: 'Compliance & Regulatory',
  detailTabsContractsAndDocuments: 'Contracts & Documents',
  detailTabsCrmRevenue: 'CRM & Revenue',
  detailTabsCustomerInfo: 'Customer Info',
  detailTabsCustomerSuccess: 'Customer Success & Health',
  listFilterPlaceholder: 'Search by customer name or code...',
  listPageTitle: 'Customers',
  listTabsActive: 'Active',
  listTabsAll: 'All',
  listTabsDraft: 'Draft',
  listTabsOnHold: 'On Hold',
  listTabsSuspended: 'Suspended',
  listTabsTerminated: 'Terminated',
  listTabsUnderReview: 'Under Review',
  payerFieldBp: 'Payer BP',
  payerFieldIsParentCompanyFlag: 'Payer Is Parent Company',
  payerFieldIsSameAsBillToFlag: 'Payer Same As Bill-To'
};
export default pagesCustomerLedgerEn;